export interface ScoreboardUserType {
    usertypeid: string;
    name: string;
}

export const SCOREBOARD_USER_TYPES: ScoreboardUserType[] = [
    {
        usertypeid: '0e5f3683-cfe2-4d34-b29a-3f027f9801a2',
        name: 'Practising Doctor',
    },
    {
        usertypeid: '2818c898-702a-4aec-ab8d-5d23101bc35f',
        name: 'Faculty',
    },
    {
        usertypeid: 'bbee9da6-3ab2-4b40-91fe-972ab2dcadce',
        name: 'Retired Doctor',
    },
    {
        usertypeid: '77822016-a9ea-4901-92a7-ab8ca1a73e0b',
        name: 'PG Student',
    },
    {
        usertypeid: '7f048020-fea8-4803-b621-576cdb1ecb60',
        name: 'UG Student or Intern',
    },
];

export const ALL_SCOREBOARD_USER_TYPE_IDS = SCOREBOARD_USER_TYPES.map(
    u => u.usertypeid,
);

export const SCOREBOARD_USER_TYPE_OPTIONS = SCOREBOARD_USER_TYPES.map(
    userType => ({
        id: userType.usertypeid,
        name: userType.name,
    }),
);
